<template>
  <div :class="`hover-item ${customClass}`">
    <!-- <div class="arrow-up"></div> -->
    <a
      v-if="item.quantity > 0"
      href="javascript:;"
      @click="addToCart(item, $event)"
      class="btn btn-primary add-to-cart btn-sm"
      >
      <span v-if="item.sale_type === 'Regular'"> Add to Cart</span>
      <span v-else> Pre Order</span>
      </a
    >

    <ReprintRequest v-else :item="item"/>

    <!-- <a
      :href="`${baseUrl}book/${item.id}`"
      class="btn btn-black view-details btn-sm"
      >View Details</a
    > -->
  </div>
</template>
<script>
import ReprintRequest from './ReprintRequest.vue';

export default {
  props: ["item", "customClass"],
  components: {
    ReprintRequest
  },
  methods: {
    addToCart(row, e) {
      // Capture the product image now (event target is recycled after the async call).
      let sourceImg = null;
      if (e && e.currentTarget) {
        const card = e.currentTarget.closest(".section-item");
        if (card) sourceImg = card.querySelector("img");
      }
      this.$http.post("cart/add", {
        session_id: localStorage.getItem("session_id"),
        product_id: row.id,
        sale_type: row.sale_type,
        user_id: localStorage.getItem("user_id")
      }).then(response => {
        if (response.data.status) {
          $(".cart-count").text(response.data.cart_count);
          localStorage.setItem("cartCount", response.data.cart_count);
          window.dispatchEvent(new Event("cart-updated"));
          if (window.fbq) {
            fbq('track', 'AddToCart', {
              content_ids: [row.id],
              content_name: row.product_name,
              content_type: 'product',
              value: parseFloat(row.price) || 0,
              currency: 'BDT'
            });
          }
          this.$flyToCart(sourceImg);
          this.flashMessage.success({ message: response.data.message });
        } else {
          this.flashMessage.error({ message: response.data.message });
        }
      }).catch(() => {
        this.flashMessage.error({ message: "একটি ত্রুটি ঘটেছে" });
      });
    }
  },
};
</script>
